//React
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button, Icon } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";
import { useRouter } from "../../../../hooks/router";

//Components
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../components/Loader";
import Loading from "../../../../components/Loading";

//Styles
import {
  Container,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
  CellButtonsContainer,
} from "./styles";

const ListarCursos = () => {
  const [search, setSearch] = useState("");
  const [cursos, setCursos] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(false);
  // const [isAtivos, setIsAtivos] = useState(true);
  const [loading, setLoading] = useState(false);

  const [idLicao, setIdLicao] = useState(null);

  const router = useRouter();

  const academyStatusOptions = {
    0: "Não finalizado",
    1: "Não publicado",
    2: "Em análise",
    3: "Com erros",
    4: "Publicado",
  };

  useEffect(() => {
    const { id_licao } = router.query;

    setIdLicao(id_licao);
  }, [router]);

  useEffect(() => {
    loadCursos(1);
  }, []);

  const loadCursos = useCallback(
    async (page) => {
      setLoading(true);

      try {
        const response = await api.get("admin/academy/cursos", {
          params: {
            search,
            page,
          },
        });

        const { cursos, pages } = response.data;

        setCursos(cursos);
        setPage(page);
        setPages(pages);
        setLoading(false);

        await systemLogs("academy/cursos/", "listou os cursos");
      } catch (err) {
        swal("Não foi possível carregar os cursos", err, "error");
        setLoading(false);
      }
    },
    [search]
  );

  const addPage = useCallback(async () => {
    const newPage = page + 1;

    setPage(newPage);
    await loadCursos(newPage);
  }, [page]);

  const removePage = useCallback(async () => {
    if (page <= 1) {
      return;
    }

    const newPage = page - 1;

    setPage(newPage);
    await loadCursos(newPage);
  }, [page]);

  const doSearch = useCallback(() => {
    loadCursos(1);
  }, [page, loadCursos]);

  const handleStatus = useCallback(
    async (index, academy_status) => {
      try {
        const curso = cursos[index];
        const newCursos = [...cursos];

        await api.put(`admin/academy/cursos/${curso.id}`, {
          curso: { academy_status },
        });

        newCursos[index].academy_status = academy_status;

        setCursos(newCursos);

        swal(
          `Curso ${academyStatusOptions[academy_status]} !`,
          `Curso ${academyStatusOptions[academy_status]} com sucesso.`,
          "success"
        );
      } catch (err) {
        console.error(err);
        swal(
          "Erro !",
          "Houve um problema ao alterar status deste curso",
          "error"
        );
      }
    },
    [cursos]
  );

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Cursos do Voitto Academy</Title>

        <ContainerInputSearch>
          <Input
            type="text"
            placeholder="Pesquise pelo titulo"
            onChange={(e) => setSearch(e.target.value)}
            onKeyUp={(e) => e.key === "Enter" && doSearch()}
          />
          <Link>
            <Button onClick={doSearch}>
              <Icon name="search" />
            </Button>
          </Link>
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Titulo</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Produtor</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Data de criação
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Acessar curso</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body className="table-body">
            {loading ? (
              <Loading
                msg={
                  !search ? "Buscando cursos..." : `Buscando por ${search}...`
                }
              />
            ) : (
              cursos.map((curso, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{curso.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.curso}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {curso?.producers?.pessoa?.nome || ""}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.data_sys}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {academyStatusOptions[curso.academy_status]}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <CellButtonsContainer>
                      <Button
                        title="Publicar"
                        icon="edit icon"
                        size="small"
                        color={"green"}
                        onClick={() => handleStatus(index, 4)}
                      />
                      <Button
                        title="Não publicar (curso sem erros)"
                        icon="edit icon"
                        size="small"
                        color={"grey"}
                        onClick={() => handleStatus(index, 1)}
                      />
                      <Button
                        title="Não publicar (curso com erros)"
                        icon="edit icon"
                        size="small"
                        color={"red"}
                        onClick={() => handleStatus(index, 3)}
                      />
                    </CellButtonsContainer>
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <CellButtonsContainer>
                      <Button
                        title="Ver curso"
                        size="small"
                        color={"blue"}
                        onClick={() =>
                          window.open(
                            `/admin/academy/cursos/${cursos[index].id}`
                          )
                        }
                      >
                        Ver Curso
                      </Button>
                      <Button
                        title="Preview Assistir"
                        size="small"
                        color={"black"}
                        onClick={() =>
                          window.open(
                            `/admin/preview/assistir/${cursos[index].id}`
                          )
                        }
                      >
                        Preview Assistir
                      </Button>
                      <Button
                        title="Creator do Curso"
                        size="small"
                        color={"orange"}
                        onClick={() =>
                          window.open(`/academy/creator/${cursos[index].id}`)
                        }
                      >
                        Academy Creator
                      </Button>
                    </CellButtonsContainer>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))
            )}
          </SemanticTable.Body>
        </SemanticTable>
        {page > 1 && (
          <Button floated="left" onClick={removePage}>
            Voltar
          </Button>
        )}

        {page < pages && (
          <Button floated="right" onClick={addPage}>
            Avançar
          </Button>
        )}
      </Content>
    </Container>
  );
};

export default ListarCursos;
